"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../utils");

var _promoClip = _interopRequireDefault(require("./promo-clip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class PromoVideo extends _promoClip.default {
  constructor(clip) {
    super();
    this.clip = clip;
    const {
      hd
    } = (0, _utils.getClipPreviewUrls)(this.clip.video); // this.sdvideo = this.createVideoElement(sd);

    this.hdvideo = this.createVideoElement(hd);
    this.activeVideo = this.hdvideo;
    this.currentTime = this.offset;
    this.isReady = new Promise(resolve => {
      this.hdvideo.oncanplaythrough = () => {
        resolve();
      };
    }); // set a default crop data - used in drawObj

    if (!this.clip.crop) {
      this.clip.crop = {
        x: 0,
        y: 0,
        w: 1280,
        h: 720,
        aspectRatio: '16:9'
      };
    }

    const {
      crop: {
        aspectRatio
      }
    } = this.clip; // current we have to force the crop object for live preview from default preview size
    // need to update the clients code to be consist
    // TODO: need to check if to handle it it in clip-utils normalizeClipCrop

    if (aspectRatio === '9:16') {
      this.clip.crop.w = 405;
      this.clip.crop.h = 720;
    } // TODO: need to check if to handle it it in clip-utils normalizeClipCrop


    if (aspectRatio === '1:1') {
      this.clip.crop.w = 720;
      this.clip.crop.h = 720;
    } // update crop by video true size


    const {
      previewTrueHeight = 720
    } = this.clip.video;
    const scale = previewTrueHeight / 720;

    if (scale !== 1) {
      this.clip.crop.x = this.clip.crop.x * scale;
      this.clip.crop.y = this.clip.crop.y * scale;
      this.clip.crop.w = this.clip.crop.w * scale;
      this.clip.crop.h = this.clip.crop.h * scale;
    }
  }

  createVideoElement(src) {
    const video = document.createElement('video');
    video.src = src;
    video.playsInline = true;
    video.autoplay = true;
    video.muted = true;
    return video;
  }

  set currentTime(time) {
    this.activeVideo.currentTime = time;
  }

  get currentTime() {
    return this.activeVideo.currentTime;
  }

  play() {
    this.activeVideo.play().catch(() => {// NotAllowedError
    });
  }

  pause() {
    this.activeVideo.pause();
  }

  get paused() {
    return this.activeVideo.paused;
  }

  get drawObj() {
    const {
      crop
    } = this.clip;

    if (this.activeVideo === this.sdvideo) {
      return {
        el: this.activeVideo,
        x: crop.x * 0.25,
        y: crop.y * 0.25,
        w: crop.w * 0.25,
        h: crop.h * 0.25
      };
    }

    return {
      el: this.activeVideo,
      ...crop
    };
  }

}

exports.default = PromoVideo;